import { createContext, FC, PropsWithChildren, useContext } from 'react';
import { Socket } from 'socket.io-client';

import { clientConfig } from '@/config/clientConfig';

import { useSocketConnection } from './useSocketConnection';

const ChatSocketContext = createContext<Socket | null>(null);

export const useChatSocket = () => {
  return useContext(ChatSocketContext);
};

export const ChatSocketProvider: FC<PropsWithChildren> = ({ children }) => {
  const socket = useSocketConnection({
    url: clientConfig.socketUrls.chat,
    namespace: 'Chat',
  });

  return <ChatSocketContext.Provider value={socket}>{children}</ChatSocketContext.Provider>;
};
